import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import MiniAppbar from "@meetyoo/components/src/components/Appbar/MiniAppbar";

import AppbarUsermenu from "../AppbarUsermenu";
import AppbarSettings from "../AppbarSettings";

import { setShowSideDrawer } from "../../../actions/ui";

export const AppbarComponent = ({ title, drawerOpen, translate, handleDrawerOpen, drawerWidth }) => {
  return (
    <MiniAppbar
      title={translate[title]}
      drawerOpen={drawerOpen}
      drawerWidth={drawerWidth}
      handleDrawerOpen={() => handleDrawerOpen(!drawerOpen)}
    >
      <AppbarSettings />
      <AppbarUsermenu />
    </MiniAppbar>
  );
};

AppbarComponent.propTypes = {
  title: PropTypes.string.isRequired,
  translate: PropTypes.object.isRequired,
  drawerOpen: PropTypes.bool.isRequired,
  handleDrawerOpen: PropTypes.func.isRequired,
  drawerWidth: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  title: state.ui.title,
  translate: state.ui.translate,
  drawerOpen: state.ui.sideDrawerOpen,
  drawerWidth: state.ui.sideDrawerWidth,
});

const mapDispatchToProps = dispatch => ({
  handleDrawerOpen: drawerOpen => dispatch(setShowSideDrawer(drawerOpen)),
});

const Appbar = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppbarComponent);

export default Appbar;
